export enum QuestionTestType {
  FillInGap = 'fill-in-gap',
  MCQ = 'mcq',
  ReorderList = 'reorder-list',
  TypeItIn = 'type-it-in',
}
